<template>
  <div>
    <div v-if="file.length === 0 && !edit"
      class="w-auto absolute inset-0 text-base text-dynamicBackBtn font-normal flex justify-center items-center gap-1 mt-6"
    >
      <Icon icon-name="upload-icon-red" size="s" />
      <p>Upload</p>
    </div>
    <div v-if="file.length === 0 && edit && !uploading">
      <input type="file" @change="handleInputFiles" ref="fileInput" hidden>
      <div @click="triggerInputFile"
        class="w-auto absolute inset-0 text-base text-dynamicBackBtn font-normal cursor-pointer flex justify-center items-center gap-1 mt-6"
      >
        <Icon icon-name="upload-icon-red" size="s" />
        <p>Upload</p>
      </div>
    </div>
    <div v-if="uploading"
      class="w-auto absolute inset-0 text-base text-dynamicBackBtn font-normal cursor-pointer flex justify-center items-center gap-1 mt-6"
    >
      Uploading...
    </div>
    <div v-if="file && file.length > 0" class="w-auto absolute inset-x-0 top-8">
      <div v-for="(item, index) in file" :key="index"
        class="w-full flex justify-center items-center"
      >
        <div class="w-auto h-full flex justify-center items-center gap-1">
          <div>
            <icon icon-name="pdf" size="xs" class="icon" v-if="item.mimeType === 'pdf'"/>
            <icon icon-name="doc" size="xs" class="icon" v-else-if="item.mimeType === 'doc'"/>
            <icon icon-name="xlsx" size="xs" class="icon" v-else-if="item.mimeType === 'xlsx'"/>
            <icon icon-name="csv" size="xs" class="icon" v-else-if="item.mimeType === 'csv'"/>
            <icon icon-name="ppt" size="xs" class="icon" v-else-if="item.mimeType === 'ppt'"/>
            <icon icon-name="png" size="xs" class="icon" v-else-if="item.mimeType === 'png'"/>
            <icon icon-name="jpg" size="xs" class="icon" v-else-if="item.mimeType === 'jpg'"/>
            <icon icon-name="jpg" size="xs" class="icon" v-else-if="item.mimeType === 'jpeg'"/>
          </div>

          <div class="flex justify-center gap-2">
            <p class="text-blackJet text-sm">
              {{ item.fileName && item.fileName.length > 12 ? item.fileName.slice(0, 12) + '...' : item.fileName }}
              .{{ item?.mimeType }}
            </p>
            <p class="text-xs text-romanSilver mt-1">
                • {{ item?.fileSize.toFixed(2) }}
            </p>
          </div>
        </div>
        <!-- <div @click="deleteUploadedFile()" class="cursor-pointer h-full w-9">
          <icon icon-name="trash-icon" size="s" class="icon"/>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  components: {  },
  name: "FilesUpload",
  props: {
    file: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
         mimeType: {
          "vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
          "vnd.openxmlformats-officedocument.wordprocessingml.document": "doc",
          "vnd.openxmlformats-officedocument.presentationml.presentation": "ppt",
          "vnd.ms-powerpoint": "ppt",
          "pptx": "ppt"
        },
        imageSizeMB: 0,
        uploading: false,
    };
  },
  methods: {
    triggerInputFile() {
      this.$refs.fileInput.click();
    },
    handleInputFiles() {
      const { files } = this.$refs.fileInput;
      const arrayfiles = Array.from(files);

      if(arrayfiles > 1){
        return this.$toasted.error("You can't upload more than 1 file.",
          { duration: 6000,}
        );
      }
      return this.validateAndUploadFile(files[0])
    },
    validateAndUploadFile(file) {
      const extension = file.type.split('/').pop().toLowerCase(); // Extract and format file type
      const type = this.mimeType[extension] || extension;
      this.fileType = type;
      const allowedFileType = [ "pdf", "doc", "xlsx", "csv", "ppt", "png", "jpg", "jpeg", "sheet"]

      if(!allowedFileType.includes(type)){
        return this.$toasted.error("Unsupported file type.", { duration: 6000 });
      }
      return this.uploadImage(file);
    },
    async uploadImage(file) {
      if (!file) return;

      this.uploading = true;
      const formData = new FormData();
      formData.append('file', file);
      const url = process.env.VUE_APP_IMAGE_UPLOAD;
      try{
        const { data } = await axios.post(url, formData, {
            onUploadProgress: (progressEvent) => {
                this.imageSizeMB = progressEvent.loaded / 1024 / 1024; // convert to MB
            }
        });
        const { name } = file;
        const fName = name.substr(0, name.lastIndexOf(".")).replace(/[\d()-]+/g, '');
        const fileExtension = file.type.split('/').pop().toLowerCase();
        const type = this.mimeType[fileExtension] || fileExtension;
        const newfile = [];
        newfile.push({
            fileUrl: data.fileUrl,
            fileSize: this.imageSizeMB,
            mimeType: type,
            fileName: fName,
          });
        this.uploading = false;
        this.$emit('file-update', newfile, this.type)
      }catch(error){
          this.uploading = false;
      };
    },
  },
  mounted() {
  }
};
</script>

<style scoped>
</style>
